import {
  validateExtensions,
  validateFileSize,
} from './helpers';

const errorText = {
  maxsize: 'Превышен лимит размера файла 10 МБ',
  type: 'Ошибка. Неверный формат файла.',
}

const extensions = ['.doc', '.docx', '.pdf', '.jpg', '.jpeg', '.png'];
const maxFileSize = 10000000;
let filesDrop = $('.js-filesDrop');
const uploadFileInput = filesDrop.find('.js-uploadFileInput');
const uploadProgress = filesDrop.find('.js-uploadProgress');
let uploadFileList = filesDrop.find('.js-uploadFileList');
let dataInputs = document.querySelector('.js-uploadFileInput-main')
let constCountInputs = null
let countInputs = null

if (dataInputs) {
  dataInputs = document.querySelector('.js-uploadFileInput-main')
    .getAttribute('data-inputs').split(',')
  constCountInputs = dataInputs.length
  countInputs = dataInputs.length

  dataInputs.shift()
}

// Проверка поддержки браузером
if(typeof(window.FileReader) == 'undefined') {
  console.log('Не поддерживается браузером!');
  filesDrop.addClass('is_error_filereader');
}

$(document).on('change', '.js-uploadFileInput', function(event) {
  const _this = $(event.currentTarget);
  const file = event.target.files[0];
  const inputWrap = _this.parents('.input__wrap');
  const fileId = $('.js-uploadFileInput').length + 1;
  filesDrop = _this.parents('.js-filesDrop');
  const uploadErrorText = filesDrop.find('.js-uploadErrorText');
  uploadFileList = filesDrop.parents('.js-fileWrapper').find('.js-uploadFileList');
  let fileListCounter = filesDrop.parents('.js-fileWrapper').find('.js-fileListCounter');
  let fileListHead = filesDrop.parents('.js-fileWrapper').find('.file__list-head');

  if(validateExtensions(file, extensions) && validateFileSize(file, maxFileSize) && countInputs){
    const currentInputName = dataInputs.shift()

    filesDrop.attr('id', 'file-' + fileId);

    filesDrop.removeClass('is_error');

    createdFileLabel(inputWrap, currentInputName);

    appendFileTemplate({ file }, uploadFileList, filesDrop, fileId);
    fileListCounter.html('');

    if (filesDrop.parents('.js-fileWrapper').find('.file__active-load').length > 0) {
      let fileLength = filesDrop.parents('.js-fileWrapper').find('.file__active-load').length;

      counterFiles(fileLength, fileListCounter);
    }

    fileListHead.addClass('is_show');

    countInputs -= 1
  } else {
    if(!validateFileSize(file, maxFileSize)){
      uploadErrorText.text(errorText.maxsize);
    } else if (!dataInputs.length) {
      uploadErrorText.text(`Достигнуто максимальное количество файлов (${constCountInputs})`)
    } else {
      uploadErrorText.text(errorText.type);
    }

    event.target.value = ''
    filesDrop.addClass('is_error');
  }
});

$(document).on('click', '.js-fileDelete', function(event) {
  const _this = $(event.currentTarget);
  const element = _this.parents('.file__active-load');
  const filesActiveLength = _this.parents('.js-uploadFileList').find('.file__active-load').length - 1;
  const fileListCounter = _this.parents('.js-fileWrapper').find('.js-fileListCounter');
  let fileListHead = _this.parents('.js-fileWrapper').find('.file__list-head');

  // idElem что б искать input который нужно удалить будет при клике на "удалить файл"
  const idElem = '#' + _this.data('id');
  const allInputFiles = _this.parents('.js-fileWrapper').find('.js-uploadFileInput')

  dataInputs.unshift($(idElem).find('.js-uploadFileInput').attr('name').split('_').pop())
  countInputs += 1

  allInputFiles.each(( index, element ) => {
    if ($(element).attr('name') === 'form_file_undefined') {
      $(element).attr('name', 'form_file_' + dataInputs.shift())
    }
  })

  filesDrop = _this.parents('.js-filesDrop');

  element.remove();

  $(idElem).remove();

  filesDrop.removeClass('is_success');

  fileListCounter.html('');
  if (filesActiveLength > 0) {
    counterFiles(filesActiveLength, fileListCounter);
  } else {
    fileListHead.removeClass('is_show');
  }
});

$(document).on('click', '.js-fileListDeleteAll', function(event) {
  const _this = $(event.currentTarget);
  const parentFileWrapper = _this.parents('.js-fileWrapper');
  const activeElems = parentFileWrapper.find('.file__active-load');

  dataInputs = document.querySelector('.js-uploadFileInput-main')
    .getAttribute('data-inputs').split(',')

  countInputs = dataInputs.length

  _this.parent().removeClass('is_show');

  activeElems.each(function() {
    const id =  '#' + $(this).find('.js-fileDelete').data('id');

    $(id).remove();
    $(this).remove();
  });

  parentFileWrapper.find('.js-uploadFileInput').attr('name', 'form_file_' + dataInputs.shift())
});

function appendFileTemplate({ file }, uploadList, filesDropElem, id){
  filesDropElem.addClass('is_success');

  let sizeFile = Number(file.size * 0.001);
  let textSize = Math.round(sizeFile) + ' KB';
  let fileName = file.name.split('.')[0];
  let format = file.name.split('.').reverse()[0];

  const tpl = `
    <div class="file__active-load">
        <div class="file__active-name"><span>${fileName}</span>${'.' + format}</div>
        <div class="file__active-items">
          <div class="file__active-size">${ textSize }</div>
          <div data-id="file-${id}" class="file__active-reset js-fileDelete">Удалить</div>
        </div>
    </div>
  `;

  uploadList.append(tpl);
}

let arrayListText = ['файл добавлен', 'файла добавлено', 'файлов добавлено'];

function declOfNum(n, text_forms) {
    n = Math.abs(n) % 100;
    var n1 = n % 10;
    if (n > 10 && n < 20) { return text_forms[2]; }
    if (n1 > 1 && n1 < 5) { return text_forms[1]; }
    if (n1 == 1) { return text_forms[0]; }
    return text_forms[2];
}

function createdFileLabel(inputWrap, id) {
  const tpl = `
    <div class="file js-filesDrop">
      <label class="file__label">
        <div class="file__button">
          <input class="file__input js-uploadFileInput" type="file" name="form_file_${id}" accept="image/jpeg,image/jpg,image/png,application/doc,application/pdf">
          <div class="js-uploadProgress"></div>
          <div class="file__title">Прикрепить файл</div>
        </div>
      </label>
      <div class="js-uploadErrorText"></div>
    </div>
  `;

  inputWrap.append(tpl);
}

function counterFiles(files, listWrap) {
  let textCurrent = declOfNum(files, arrayListText);
  let tpl = `
    <span>${files} ${textCurrent}</span>
  `;

  listWrap.append(tpl);
}
